$wrapper.on("click", ".toggler", function (e) {
  let $this = $(this);
  let toggleClass = "active";
  if (
    typeof $this.data("toggle-class") !== "undefined" &&
    $this.data("toggle-class") != null
  ) {
    toggleClass = $this.data("toggle-class");
  }
  if (toggleClass.indexOf(",") < 0) {
    if (
      typeof $this.data("target") !== "undefined" &&
      $($this.data("target")).length
    ) {
      $($(this).data("target")).toggleClass(toggleClass);
    }
  } else {
    let classes = toggleClass.split(",");
    if (typeof $this.data("target") !== "undefined") {
      let targets = $this.data("target").split(",");
      if (classes.length == targets.length) {
        for (let i = 0; i < classes.length; i++) {
          $(targets[i]).toggleClass(classes[i]);
        }
      }
    } else {
      for (let i = 0; i < classes.length; i++) {
        $(this).toggleClass(classes[i]);
      }
    }
  }

  if (
    typeof $this.data("empty-field") !== "undefined" &&
    $($this.data("empty-field")).length
  ) {
    $($(this).data("empty-field")).val("");
  }
  if (
    typeof $this.data("prevent-default") !== "undefined" &&
    $($this.data("prevent-default")).length
  ) {
    e.preventDefault();
  }
  if ($this.hasClass("remove")) {
    if (
      typeof $this.data("remove") !== "undefined" &&
      $($this.data("remove")).length
    ) {
      $($this.data("remove")).remove();
    } else {
      $this.remove();
    }
  }
});

$wrapper.on("change", ".change-toggler", function (e) {
  e.preventDefault();

  let value = $(this).data("toggler");
  let target = $(this).data("target");
  let className = $(this).data("toggle-class");

  let toggleSwitch = $(this).data("toggle-switch");
  let currentValue = $(this).val();

  if (currentValue.endsWith(value) && !$(target).hasClass(toggleSwitch)) {
    $(target).toggleClass(className);
    $(target).toggleClass(toggleSwitch);
  } else if ($(target).hasClass(toggleSwitch)) {
    $(target).toggleClass(className);
    $(target).toggleClass(toggleSwitch);
  }
});

let scrollTimeout = null;
$wrapper.on("click", ".scroller", function (e) {
  e.preventDefault();
  let $this = $(this);
  let id = $this.data("scroller")
  ? $this.data("scroller")
  : $this.attr("href");
  let scrollIt = () => {

    $("html, body").animate(
      {
        scrollTop:
          $(id).offset().top -
          ($this.data("offset") ? $this.data("offset") : 0),
      },
      ($this.data("scroller-duration") != undefined ? $this.data("scroller-duration") : "fast")
    );
  };

  if ($this.hasClass("toggler")) {
    clearTimeout(scrollTimeout);
    setTimeout(scrollIt, 250);
  } else if ($this.data("scroller-duration") == "0") {
    $("html, body").scrollTop($(id).offset().top - 
    ($this.data("offset") ? $this.data("offset") : 0));
  } else {
    scrollIt();
  }
});

$wrapper.on("change", ".change-scroller", function (e) {
  e.preventDefault();

  let id = $(this).data("scroller")
    ? $(this).data("scroller")
    : $(this).attr("href");
  $("html, body").animate(
    {
      scrollTop:
        $(id).offset().top -
        ($(this).data("offset") ? $(this).data("offset") : 0),
    },
    "fast"
  );

  if (
    typeof $(this).data("repeat") !== "undefined" &&
    $(this).data("repeat") == "no"
  ) {
    $(this).removeClass("change-scroller");
  }
});

$wrapper.on("click", ".expander", function (e) {
  e.preventDefault();

  let id = $(this).data("expander")
    ? $(this).data("expander")
    : $(this).attr("href");

  if ($wrapper.find(id).length) {
    $wrapper.find(id).removeClass("expandible");
    $(this).remove();
  }
});

$wrapper.on("click", ".clicker", function (e) {
  e.preventDefault();

  let clickClass = $(this).data("clicker")
    ? $(this).data("clicker")
    : $(this).attr("href");

  if (clickClass !== undefined) {
    if (clickClass.indexOf(",") < 0) {
      if ($wrapper.find(clickClass).length) {
        $(clickClass).trigger("click");
      }
    } else {
      let classes = clickClass.split(",");
      for (let i = 0; i < classes.length; i++) {
        if ($(classes[i]).length > 0) {
          $(classes[i]).trigger("click");
        }
      }
    }
  }
});

$wrapper.on(
  "click",
  ".uncollapser:not(.uncollapser--with-nesting)",
  function (e) {
    e.preventDefault();
    let $parent = $(this).parents(".collapser-context").eq(0);

    if ($(this).hasClass("open")) {
      $parent.find(".collapse").addClass("collapsed").removeClass("collapse");
    } else {
      $parent.find(".collapsed").addClass("collapse").removeClass("collapsed");
    }
    // var toggleClasses = null;
    // if (typeof (toggleClasses = $parent.data('collapser-toggle-class')) !== 'undefined') {
    //     $parent.toggleClass(toggleClasses)
    // }
    $parent.find(".uncollapser").toggleClass("open");
  }
);

$wrapper.on("click", ".uncollapser.uncollapser--with-nesting", function (e) {
  e.preventDefault();
  let $target = $($(this).data("collapser-target")) || $(this).next();
  let $parent = $(this).parents(".collapser-context").eq(0);

  $(this).toggleClass("open");
  $target.eq(0).toggleClass("collapse collapsed");
  $(this)
    .siblings(".uncollapser.open")
    .each(function () {
      let $target = $($(this).data("collapser-target")) || $(this).next();
      $target.eq(0).addClass("collapsed").removeClass("collapse");
      $(this).removeClass("open");
    });
  // var toggleClasses = null;
  // if (typeof (toggleClasses = $parent.data('collapser-toggle-class')) !== 'undefined') {
  //     $parent.toggleClass(toggleClasses)
  // }
  // let active = $parent.find('.uncollapser.open').length > 0 ? $parent.addClass('active') : $parent.removeClass('active')
});

$wrapper.on("click", ".field-loader", handleFieldLoader);
$("body").on("click", ".field-loader", handleFieldLoader);

function handleFieldLoader(e) {
  e.preventDefault();

  let id = $(this).data("expander")
    ? $(this).data("expander")
    : $(this).attr("href");

  if ($wrapper.find(id).length) {
    $(id).removeClass("expandible");
    $(this).remove();
  }
  let field = $(this).attr("data-field");
  let locale = $(this).attr("data-locale") || null;
  if (field != null) {
    window
      .fetch(
        window.Routing.generate("_rental_field." + locale, {
          id: $("#rental").data("id"),
          field: field,
        })
      )
      .then((res) => res.json())
      .then(
        (result) => {
          let div;
          if (result && result.startsWith("[")) {
            let items = JSON.parse(result);
             div = $("<div id='" + field + "_"+locale +" class='block'></div>");
            items.forEach((item) => {
              if(item[locale] !== undefined)
                div.append("<p class='block pb-1'>" + item[locale].replace(/\n/g, "<br>") + "</p>");
            });
            } else {
             div = $(
              "<p class='block pb-1'>" + result.replace(/\n/g, "<br>") + "</p>"
            );
            }
          $(this).after(div);
          $(this).remove();
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          console.log(error);
        }
      );
  } else {
    let result = $(this).attr("data-value");
    let classList = $(this).attr("data-class");
    let div = $(
      "<p class='" +
        (classList != null ? classList : "block p-0 pb-1 m-0") +
        "'>" +
        result +
        "</p>"
    );
    $(this).after(div);
    $(this).remove();
  }
}

$wrapper.on("click", ".dropdown > .dropdown-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("open");
});

if ($(".show-actions").length) {
  function showActions($context) {
    if ($context.find(".collapsed").length == 0) {
      $context.find(".show-more").addClass("hidden");
    } else {
      $context.find(".show-more").removeClass("hidden");
    }

    if ($context.find(".collapse").length == 0) {
      $context.find(".show-less").addClass("hidden");
    } else {
      $context.find(".show-less").removeClass("hidden");
    }
  }

  $wrapper.on("click", ".show-actions .show-more", function (e) {
    e.preventDefault();
    let $context = $(this).parents(".show-context").eq(0);
    $context
      .find(".collapsed:lt(5)")
      .addClass("collapse")
      .removeClass("collapsed");
    showActions($context);
  });

  $wrapper.on("click", ".show-actions .show-less", function (e) {
    e.preventDefault();
    let $context = $(this).parents(".show-context").eq(0);
    $context
      .find(".collapse:lt(5)")
      .addClass("collapsed")
      .removeClass("collapse");
    showActions($context);
  });
}

$wrapper.on("click", ".filter-toggler", function (e) {
  e.preventDefault();
  if (
    typeof $(this).data("target") !== "undefined" &&
    $($(this).data("target")).length
  ) {
    $($(this).data("target")).toggleClass("close");
  }
});

$wrapper.on("click", ".locator", function () {
  $(".search-teaser .dropdown-toggle:visible").trigger("click");
});

$wrapper.on("click", "a.durl, em.durl", function (e) {
  e.preventDefault();
  window.location = $(this).attr("data-url");
});

$wrapper.on("change", ".durl", function () {
  window.location =
    $(this).find(":selected").attr("data-url") || $(this).attr("data-url");

  // this method would be nice but javascript is not working properly
  // $.ajax({
  //     url: $(this).find(':selected').attr('data-url'),
  //     success: function(data) {
  //         $('.search-teaser .location').html($(data).find('.search-teaser .location').html());
  //         $('#result').html($(data).find('#result').html());
  //     },
  //     error: function() {
  //     }
  // });
});
$wrapper.on("mouseup", ".range-url", function () {
        let selectedDistance = $(this).val();
        let baseUrl = $(this).data('url');
        let url = new URL(baseUrl);
        let params = new URLSearchParams(url.search);

        if (params.has('distance')) {
          params.set('distance', selectedDistance);
        } else {
          params.append('distance', selectedDistance);
        }

        url.search = params.toString();
        let rangeUrl = url.toString();
        window.location = rangeUrl;
});
$wrapper.on("click", ".reset", function (e) {
  e.preventDefault();
  if ($(this).data("scope") != null && $(this).data("scope") == "prices") {
    $(this).parents("form").eq(0).find("#price input[type=text]").val("");
    $(this)
      .parents("form")
      .eq(0)
      .find("#price input:checked")
      .prop("checked", false);
  } else if (
    $(this).data("scope") != null &&
    $(this).data("scope") == "equipment"
  ) {
    $(this)
      .parents("form")
      .eq(0)
      .find("#equipment input:checked")
      .prop("checked", false);
  } else {
    $(this).parents("form").eq(0).find("input:checked").prop("checked", false);
    $(this).parents("form").eq(0).find("input[type=text]").val("");
    $(this).parents("form").eq(0).find("select").val("");
    $(this).parents("form").eq(0).find("input[type=hidden]").remove();
  }
  $(this).parents("form").eq(0).find("[type=submit]").trigger("click");
});

$wrapper.on(
  "click",
  ".tabnav.in-page-navi .item:not(.scroller):not(.jumper):not(.link)",
  function (e) {
    e.preventDefault();
    if (!$(this).hasClass("active") && $($(this).attr("href")).length) {
      let $elem = $(this);

      if ($elem.parents("li").length > 0) {
        $elem = $elem.parents("li").eq(0);
      }
      $elem.toggleClass("active").siblings().removeClass("active");
      $($(this).attr("href"))
        .toggleClass("active")
        .siblings(".active")
        .toggleClass("active");
    }
    if ($(".slider.type-teasers").length) {
      $(".slider.type-teasers .items").slick("setPosition");
    }

    if ($(this).parents(".affixed").length > 0) {
      var $affixParent = $(this).parents(".affixed").parent();
      var scrollTop = $(window).scrollTop();
      if (scrollTop > $affixParent.offset().top + 100) {
        let scrollerDuration = $(this).data("scroller-duration") != undefined ? $this.data("scroller-duration") : 0;
        // && scrollTop > $affixParent.parent().offset().bottom
        $("html, body").animate(
          {
            scrollTop: $affixParent.offset().top,
          },
          scrollerDuration
        );
      }
    }
  }
);

if ($(".autoremove").length) {
  $(".autoremove").each(function (index, item) {
    setTimeout(function () {
      $(item).slideUp("200");
      setTimeout(function () {
        $(item).remove();
      }, 550);
    }, $(item).data("timeout"));
  });
}

$wrapper.on("click", ".languageBox .nav li", function () {
  var $this = $(this);
  $this.siblings().removeClass("active");
  $this.addClass("active");
  $this.parents(".languageBox").find(".content > div").removeClass("active");
  $this
    .parents(".languageBox")
    .find(".content > " + $this.data("ref"))
    .addClass("active");
});

$wrapper.on("click", ".overlay-menu .overlay", function () {
  var $this = $(this);
  $this.siblings().removeClass("active");
  $this.addClass("active");
  $this.parents(".languageBox").find(".content > div").removeClass("active");
  $this
    .parents(".languageBox")
    .find(".content > " + $this.data("ref"))
    .addClass("active");
});
